import {fabric} from "fabric-with-gestures";

export default class Table {
  angle = 0;
  dist = null;
  zoneId = null;
  groupName = 'Стол';
  tableName = null
  groupId = 'table_id-'+Math.ceil(Math.random() * (900000000 - 1) + 1 + Math.random() * (9999999999 - 1) + 1) + ''
  colorTable = '#dddddd';
  colorChair = '#aaaaaa';
  countPerson = 4;
  chairs = [];
  group = [];
  position = {
    top: 300,
    left: 300
  };

  constructor() {
    this.addTableTable();
  }

  addTableTable() {
    this.tableName = new fabric.Text(this.groupName.toUpperCase(), {
      my : {
         type : 'Text'
      },
      fontFamily: 'Arial',
      fontWeight: 'bold',
      centeredRotation: false,
      fontSize: 16,
      originX: 'center',
      originY: 'center',
      textAlign: 'center',
      fill: '#656565',
      angle: -this.angle,
      objectCaching: false
    });
  }

  build() {
    this.addTableTable();
    this.group = [];
    this.drawChairs()
      .drawTable()
      .calculatePositionTableName()

    this.group = this.group.concat(this.chairs);

    this.group.push(this.tableName)
    let object = new fabric.Group(this.group, {
        my: {
          id: this.groupId,
          type : this.getType()
        },
      objectCaching: false,

        left: this.position.left,
        top: this.position.top,
        angle: this.angle,
        originX: 'center',
        originY: 'center',
        perPixelTargetFind: true
      }
    );
    this.setControlsVisibility(object);
    return object
  }
}
